import useApi from "../../use/useApi";
import {useSelector} from "react-redux";
import isNull from "../../mixin/isNull";
import LegalDocumentTemplate from "../../entity/user/LegalDocumentTemplate";

const SERVICE = "service-user";
const ENTITY = "legal_document_templates";

export default function () {
    const {findOneBy, findAll, create, update} = useApi();
    const state = useSelector;
    const newInstance = data => new LegalDocumentTemplate(data);

    return {
        findOneById(id) {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.[id]);

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findOneBy(SERVICE, ENTITY, "id", id, newInstance, "entrepreneur");
                }
            }
        },
        findAll() {
            return {
                select() {

                    const result = state(state => state.api?.user?.[ENTITY]?.filter(ldt => !isNull(ldt)));

                    if (isNull(result)) return null;

                    return result;
                },
                exec() {
                    findAll(SERVICE, ENTITY, newInstance, "entrepreneur");
                }
            }
        }
    }
}